/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateStorageKanbanInput = {
    columns: Record<string, any>;
    id: string;
};
export type StorageKanbanBoardMutationVariables = {
    input: UpdateStorageKanbanInput;
};
export type StorageKanbanBoardMutationResponse = {
    readonly updateStorageKanban: {
        readonly storageKanban: {
            readonly id: string;
            readonly columns: Record<string, any>;
        };
    };
};
export type StorageKanbanBoardMutation = {
    readonly response: StorageKanbanBoardMutationResponse;
    readonly variables: StorageKanbanBoardMutationVariables;
};



/*
mutation StorageKanbanBoardMutation(
  $input: UpdateStorageKanbanInput!
) {
  updateStorageKanban(input: $input) {
    storageKanban {
      id
      columns
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateStorageKanbanPayload",
    "kind": "LinkedField",
    "name": "updateStorageKanban",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StorageKanban",
        "kind": "LinkedField",
        "name": "storageKanban",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "columns",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorageKanbanBoardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorageKanbanBoardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df7c36693937c2005050d58c43e106ed",
    "id": null,
    "metadata": {},
    "name": "StorageKanbanBoardMutation",
    "operationKind": "mutation",
    "text": "mutation StorageKanbanBoardMutation(\n  $input: UpdateStorageKanbanInput!\n) {\n  updateStorageKanban(input: $input) {\n    storageKanban {\n      id\n      columns\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '437afc815fcb74f7bca1fb7368f0ed1a';
export default node;
